import React, { Component, useState } from 'react';
import { getLanguage } from '../../../../selectors/userSelectors';
import { resolvePublicAssets } from '../../../../utils';
import { customerSettingFeaturesService } from '../../types/customerSettingFeaturesService';
import TransparentButton from '@axa-asia/emma-stylesheet/lib/components/TransparentButton/TransparentButton';
import './style.scss';
import { goto } from '../../../../actions/historyActions';

export const CustomerProfileSetting = (
  props: customerSettingFeaturesService,
) => {
  const [isShowActiveIcon, setIsShowActiveIcon] = useState(false);

  // This is onHover
  const onMouse = (val: any) => {
    setIsShowActiveIcon(val);
  };

  const onClick = (event: any) => {
    const { deepLink } = props;
    const url =
      deepLink && deepLink.query && (deepLink.query.id || deepLink.query.url);
    if (url) {
      goto(url);
    }
  };

  const { id, label, icon, iconActive } = props;
  const defaultIcon = resolvePublicAssets(
    `assets/${icon.replace('images/', 'images/customer-profile/')}`,
  );
  const activeIcon = resolvePublicAssets(
    `assets/${iconActive.replace('images/', 'images/customer-profile/')}`,
  );
  const iconPath = isShowActiveIcon ? activeIcon : defaultIcon;
  const settingDesc = label[getLanguage()];
  const TransparentButtonProps = {
    id,
    iconPath,
    settingDesc,
    isShowActiveIcon,
    onMouse,
    onClick,
  };
  return <TransparentButton {...TransparentButtonProps} />;
};
